import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import useIcons from '@/composables/useIcons'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useSegment from '@/composables/useSegment'
  import CheckoutApi from '@/services/api/CheckoutApi'
  import type { BillingHistory } from '@/services/interfaces/Checkout'
  import type { Nullable } from '@/services/interfaces/Content'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Billing',
  setup(__props) {

  const { vectorRight } = useIcons()
  const { formatDate, setIsLoadingComponentViewData } = useCommonMixin()
  const { trackPage, pageViewed, invoiceDownloaded } = useSegment()
  const billingHistory = ref(null as Nullable<BillingHistory[]>)
  const fetchingBillingHistory = ref(false)

  const noBillingHistoryYet = computed(() => {
    return billingHistory.value === null || !billingHistory.value.length
  })

  const isCourse = computed(() => {
    return (productType: string): boolean => {
      return productType === 'course'
    }
  })

  const fetchBillingHistory = async (): Promise<void> => {
    fetchingBillingHistory.value = true
    await CheckoutApi.billingHistory()
      .then((records) => {
        billingHistory.value = records
      })
      .finally(() => {
        fetchingBillingHistory.value = false
      })
  }

  const trackDownloadInvoice = (productType: string, invoiceUrl: string) => {
    invoiceDownloaded(productType, invoiceUrl)
  }

  onMounted(() => {
    fetchBillingHistory()
    trackPage('Billing Page')
    pageViewed('Billing Page')
  })

  watch(fetchingBillingHistory, (value) => {
    setIsLoadingComponentViewData(value)
  })

return { __sfc: true,vectorRight, formatDate, setIsLoadingComponentViewData, trackPage, pageViewed, invoiceDownloaded, billingHistory, fetchingBillingHistory, noBillingHistoryYet, isCourse, fetchBillingHistory, trackDownloadInvoice, computed, onMounted, ref, watch, LoadingSpinner, useIcons, useCommonMixin, useSegment, CheckoutApi }
}

})